import { useEffect, useState } from "react";

import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import CheckoutFormNew from "./CheckoutFormNew";
import { loadStripe } from "@stripe/stripe-js";
import tierHeader from "./tierHeader"
import { useDataManager } from "../backend/DataManager";
import { Navigate, useNavigate, useParams } from "react-router-dom";


export const TestProMonthlyPriceID = "price_1Pya2A2KS8DEwxEgeKfOGcfM"
export const TestProAnnualPriceID = "price_1PyZPW2KS8DEwxEgjImfVmjE"

export const ProMonthlyPriceID = "price_1QXljG2KS8DEwxEggRQ8DWwt"
export const ProAnnualPriceID = "price_1Qklb12KS8DEwxEgsdDry0hP"


function Pro() {
  const [stripePromise, setStripePromise] = useState(null);
  const {priceIDToBuyMonth, setPriceIDToBuyMonth, priceIDToBuyAnnual, setPriceIDToBuyAnnual} = useDataManager();

  useEffect(() => {
    fetch("https://payment-pqnu.onrender.com/config").then(async (r) => {
      const { publishableKey } = await r.json();
      setStripePromise(loadStripe(publishableKey));
    });
  }, []);

  const navigate = useNavigate();
  const handleExistingUserClick = () => {
    setPriceIDToBuyAnnual(ProAnnualPriceID)
    setPriceIDToBuyMonth(ProMonthlyPriceID)
    navigate("/existingUser/Login")
  }

  return (
    <>
    
    {tierHeader("Pro")}
      {stripePromise && (
        <Elements stripe={stripePromise} >
          <CheckoutFormNew tier = {2} monthly={ProMonthlyPriceID} annual={ProAnnualPriceID} founders = {false}/>
        </Elements>
        
      )}
    </>
  );
}

export default Pro;
